import { render, staticRenderFns } from "./create-support.component.html?vue&type=template&id=e90d57a2&scoped=true&"
import script from "./create-support.component.ts?vue&type=script&lang=ts&"
export * from "./create-support.component.ts?vue&type=script&lang=ts&"
import style0 from "./create-support.component.scss?vue&type=style&index=0&id=e90d57a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90d57a2",
  null
  
)

export default component.exports